export default "__VITE_ASSET__148d401f__"